import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { Firmware } from 'app/models/firmware.model';
import { User } from 'app/models/user.model';
import { CompanyService } from 'app/services/company.service';
import { FirmwareService } from 'app/services/firmware.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from "../../base-form.component";


@Component({
    selector: 'app-firmware-form',
    templateUrl: './firmware-form.component.html',
    styleUrls: ['./firmware-form.component.scss']
})
export class FirmwareFormComponent extends BaseFormComponent implements OnInit {

    private _firmware: Firmware = {}
    public fileData: File[] = []
    public companyId: number;
    public selectedCompany: number;
    public companyList: Array<Company>
    public get model() {
        return this._firmware
    }
    public set model(v: Firmware) {
        this._firmware = v;
    }
    constructor(
        private _firmwareService: FirmwareService,
        private toasterService: ToasterService,
        private _companyService: CompanyService,
        private _translateService:TranslateService
    ) {
        super();
    }


    public async ngOnInit() {
        this.companyId=parseInt(localStorage.getItem("CompanyID"));

        if (parseInt(localStorage.getItem("CompanyID")) == 1) {
            try {
                this.companyList = await this._companyService.getCompanies();
            } catch (error) {
                console.warn(error);
            }
        }
    }

    public fileChange(f) {
        try {
            this.fileData.push(f[0])
        } catch (error) {
            console.warn(error);
        }
    }
    public async save(form: NgForm) {
        if (form.form.invalid) {
            this.toasterService.toastWarning(this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY"))
            return
        }
        if (this.fileData.length == 0) {
            this.toasterService.toastWarning(this._translateService.instant("FILE_NOT_SELECTED"))
            return;
        }
        this.model.status =true;
        this.model.companyId = parseInt(localStorage.getItem("CompanyID")) == 1 ? this.selectedCompany : parseInt(localStorage.getItem("CompanyID"));
        const formData = new FormData();
        this.model.UDate = new Date;
        formData.append("files", this.fileData[0])
        try {
            let uresponse = await this._firmwareService.upload(formData)
            this.model.FileName = uresponse.toString();
            if (uresponse[0] != null) {
                await this._firmwareService.add(this.model);
                this.added.emit(true);
            }
        } catch (error) {
            console.warn(error);
            this.added.emit(false);
        }
    }

}
